import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InactivityService } from '../services/inactivity.service';

@Injectable()
export class InactivityInterceptor implements HttpInterceptor {

  constructor(private inactivityService: InactivityService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Define the conditions for requests to reset the inactivity timer
    const urlsToMonitor: string[] = [
      '/api/terrain/',
      '/proto.'
    ];

    if (urlsToMonitor.some(url => request.url.includes(url))) {
      this.inactivityService.resetInactivityTimer();
    }

    return next.handle(request);
  }
}
